export default "__VITE_ASSET__DNYTjJke__"